import Resource from './Resource';

export default class Log extends Resource{
	constructor( options = {} ){
		let {
			query = {},
			routeParams = {},
		} = options;

		let config = { 
			route: "logs/:studentRid/last-checked",
			query: query,
			routeParams: routeParams,
		};
		super(config);
		return this;
	}

	post(){
		return this.request("post");
	}
}
